import { define } from 'wicked-elements'
import { colorGenerator } from '../lib/colors'

define('[data-component~="use-color"]', {
  init() {
    const color = colorGenerator.next()
    this.element.style.setProperty('--accent', `var(--${color})`)
  },
})
